import { useCallback } from 'react';
import { useQuery } from 'react-query';

import { axios } from 'configurations/axios';
import { ILazyDropdownOption } from 'components/lazyDropdown/LazyDropdown';
import { IServerDropdownOption } from 'components/serverDropdown/ServerDropdown';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { INameTokenViewModel } from 'models/interfaces/INameTokenViewModel';
import { useSessionStore } from 'session/useSessionStore';

export const useGetSurveyByName = () => {
    const { tenantConfig, jwt } = useSessionStore((state) => ({
        tenantConfig: state.tenantConfiguration,
        jwt: state.jwtToken,
    }));

    const fetchSurveys = useCallback(async (name: string): Promise<ILazyDropdownOption<INameTokenViewModel>[]> => {
        const response = await axios.get<IResponseAPI<INameTokenViewModel[]>>(
            `${tenantConfig?.endpoints.webApiHost}/SurveyManagement/Survey/GetSurveyByName`,
            {
                params: { name },
                headers: {
                    Authorization: 'Bearer ' + jwt,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data.Result.map((item) => ({ value: item, label: item.Name }));
    }, [tenantConfig?.endpoints.webApiHost, jwt]);

    return { fetchSurveys };
};

export const useGetProductBySurvey = (surveyToken: string | undefined) => {
    const { tenantConfig, jwt } = useSessionStore((state) => ({
        tenantConfig: state.tenantConfiguration,
        jwt: state.jwtToken,
    }));

    return useQuery<IServerDropdownOption<string>[]>(
        ['ProductBySurvey', surveyToken],
        async () => {
            const response = await axios.get<IResponseAPI<INameTokenViewModel[]>>(
                `${tenantConfig?.endpoints.webApiHost}/SurveyManagement/Product/GetProductBySurvey`,
                {
                    params: { surveyToken },
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result.map((item) => ({ value: item.Token, label: item.Name }));
        },
        {
            enabled: !!surveyToken && !!tenantConfig?.endpoints.webApiHost,
        }
    );
};
